export default __webpack_public_path__ + "static/media/21.d4009513.gif";